import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { OutputTestCalculationSchema } from '../schema/OutputTestCalculationSchema';
import { OutputDataUrl } from './OutputDataUrl';
import { OutputTestCalculationType } from '../schema/types';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';

export const getTestCalculation = (dagRunId: string) =>
  apiClient
    .get<OutputTestCalculationType>(
      expand(OutputDataUrl.TEST_CALCULATIONS, { dagRunId }),
    )
    .then((response) => OutputTestCalculationSchema.parse(response.data));

export const useTestCalculateQuery = createApiQueryHook(
  ['outputTestCalculations'],
  getTestCalculation,
);
